import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Plan } from "@modules/plans/types";
import { PlanFormValues } from "@modules/plans/validations";

import { createPlanService } from "./service";
import { UseCreatePlanMutationOptions } from "./types";

export function useCreatePlanMutation(
  options?: UseCreatePlanMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Plan, ApiError, PlanFormValues>({
    mutationFn: createPlanService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
